import React from 'react'

export default function PublicationNot() {
  return (
    <h2> publicasion no encontrada</h2>
  )
}
